module.exports = "<div class=\"thin-border-panel\">\n    <div class=\"checkbox form-group\">\n        <label>\n            <input id=\"terms\" class=\"required\" name=\"terms\" type=\"checkbox\" ng-model=\"vm.checkedTerms\" ng-change=\"vm.checkTerms()\"/>\n            <strong>I agree with the <a target=\"_blank\" class=\"contact-link\" href=\"/page/terms-conditions/\">Terms &amp; Conditions</a></strong>\n        </label>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./static/js/app/layout/formly/types/order-terms-check.html
// module id = 609
// module chunks = 1